import { render } from "./Realtime.vue?vue&type=template&id=9487b50c"
import script from "./Realtime.vue?vue&type=script&lang=js"
export * from "./Realtime.vue?vue&type=script&lang=js"

import "./Realtime.vue?vue&type=style&index=0&id=9487b50c&lang=scss"

import exportComponent from "/Users/user/Desktop/prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__